<template>
  <el-dialog
    :visible.sync="innerShow"
    custom-class="cs-dialog-mask"
    :close-on-click-modal="false" 
    :modal-append-to-body="false"
  >
    <div class="cs-theme">专属{{ type==='cs'? '客服':'商务' }}</div>
    <div class="qrcode">
      <img :src="type==='cs' ? peerCSData.wx_qrcode : peerBdData.wx_qrcode" alt="" />
    </div>
    <div class="title" v-if="type==='cs'">签证专家{{ peerCSData.cs_name }}为您服务</div>
    <div class="title" v-else-if="type==='bd'">商务拓展{{ peerBdData.bd_name }}为您服务</div>
    <template v-if="type === 'cs'">
      <div class="week">{{ working_time_list[0] }}</div>
      <div class="time">{{ working_time_list[1] }}</div>
    </template>
  </el-dialog>
</template>
  
<script>
import { mapState } from 'vuex';

export default {
  props: {
    peerCSData: {
      type: Object,
      default: () => ({}),
    },
    peerBdData: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'cs',
    },
  },
  computed: {
    ...mapState('config', [
      'customer_service',
    ]),
    innerShow: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    working_time_list() {
      const working_time = this.peerCSData.working_time
        ? this.peerCSData.working_time
        : this.customer_service.working_time;
      const working_time_list = working_time ? working_time.split(' ') : [];
      const work = working_time_list[0];
      working_time_list.splice(0, 1);
      const time = working_time_list.length ? working_time_list.join(' ') : '';
      return [work, time];
    },
  },
};
</script>
<style lang="less">
.cs-dialog-mask.el-dialog {
    width: 400px;
    height: 416px;
    margin-bottom: 0;
  .el-dialog__body{
    padding: 0 32px 32px;
    text-align: center;
  }
}

</style>
<style lang="less" scoped>
.cs-dialog-mask {
  display: inline-block;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  text-align: center;
  padding: 32px;
  position: relative;
  .el-dialog__body{
    .cs-theme {
      text-align: center;
      font-size: 20px;
      color: #2f333d;
      margin-top: -10px;
    }
    .qrcode {
      width: 200px;
      height: 200px;
      margin: 24px auto 16px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title {
      color: #599fff;
      font-size: 20px;
      line-height: 28px;
      margin: 20px auto 0;
      font-weight: 500;
    }
    .week,
    .time {
      color: #5f666e;
      font-size: 16px;
      line-height: 22px;
      font-weight: 400;
    }
    .week {
      margin: 12px auto 8px;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/custom-service/components/exclusive-cs-dialog.vue